var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _g, _rect, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamsPrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 42.625C59.375 41.5204 60.2704 40.625 61.375 40.625H98C99.1046 40.625 100 41.5204 100 42.625V64.0625C100 75.2808 90.9058 84.375 79.6875 84.375V84.375C68.4692 84.375 59.375 75.2808 59.375 64.0625V42.625Z",
    fill: "url(#paint0_linear_2919_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 36.375C28.125 35.2704 29.0204 34.375 30.125 34.375H76.125C77.2296 34.375 78.125 35.2704 78.125 36.375V68.75C78.125 82.5571 66.9321 93.75 53.125 93.75V93.75C39.3179 93.75 28.125 82.5571 28.125 68.75V36.375Z",
    fill: "url(#paint1_linear_2919_149)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.375,
    cy: 25,
    r: 9.375,
    fill: "#34439E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.375,
    cy: 25,
    r: 9.375,
    fill: "url(#paint2_linear_2919_149)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.25,
    cy: 18.75,
    r: 12.5,
    fill: "url(#paint3_linear_2919_149)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2919_149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 51,
    height: 94
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.125 31.25C61.7546 31.25 68.75 24.2546 68.75 15.625C68.75 6.99539 61.7546 0 53.125 0C44.4954 0 37.5 6.99539 37.5 15.625C37.5 24.2546 44.4954 31.25 53.125 31.25Z",
    fill: "url(#paint4_linear_2919_149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9557 34.375C29.8401 34.375 28.125 36.0901 28.125 38.2057V68.75C28.125 82.5573 39.3177 93.75 53.125 93.75C66.9323 93.75 78.125 82.5573 78.125 68.75V38.2057C78.125 36.0901 76.4099 34.375 74.2943 34.375H31.9557Z",
    fill: "url(#paint5_linear_2919_149)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2919_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 31.125C21.875 29.4681 23.2181 28.125 24.875 28.125H59.5C61.1569 28.125 62.5 29.4681 62.5 31.125V81.375C62.5 83.0319 61.1569 84.375 59.5 84.375H21.875V31.125Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21.875,
    width: 56.25,
    height: 56.25,
    rx: 2,
    fill: "url(#paint6_linear_2919_149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 34.375H15.625V40.1085H24.9842V65.625H31.2658V40.1085H40.625V34.375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_149",
    x1: 59.375,
    y1: 42.9276,
    x2: 100.497,
    y2: 69.7984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_149",
    x1: 28.125,
    y1: 60.637,
    x2: 78.125,
    y2: 60.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7084EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2919_149",
    x1: 75,
    y1: 16.6118,
    x2: 93.1135,
    y2: 29.3584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2919_149",
    x1: 47.3214,
    y1: 9.82143,
    x2: 63.3929,
    y2: 28.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2919_149",
    x1: 41.9643,
    y1: 4.46429,
    x2: 62.0536,
    y2: 27.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2919_149",
    x1: 41.9643,
    y1: 4.46429,
    x2: 62.0536,
    y2: 27.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2919_149",
    x1: -1.62981e-7,
    y1: 50,
    x2: 56.25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C56B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsPrdct);
export default __webpack_public_path__ + "static/media/teams-prdct.0fef7212109a4a0cb550b658449cfbe0.svg";
export { ForwardRef as ReactComponent };